export const animationDelay = 750;
export const skeletonVisibilityDelay = 100;
